import { Layout, Drawer, DrawerProps, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import {AppHeader} from "../Header/AppHeader";
import {Outlet, useLocation} from "react-router-dom";
import React, {Suspense} from "react";
import {AppFooter} from "@/components/Footer/AppFooter";
import {useStore} from "@/store/useStore";
import {MtpFiltersBar} from "@/components/Filters/MtpFiltersBar";
import {getRootPageRoute} from "@/routes/routes";
import {ReserveModal} from "@/components/Modals/ReserveModal/ReserveModal";
import { LoginOrRegistrationModal } from "../Modals/LoginOrRegistrationModal/LoginOrRegistrationModal";

export const PageLayout = () => {
    const { Header, Footer, Content } = Layout;
    const {isSidebarOpen, hideSidebar, isMobile, isTablet, loading} = useStore();
    const location = useLocation();

    const drawerStyles: DrawerProps['styles'] = {
        body: {
            padding: '3px',
            backgroundColor: 'rgb(245, 245, 245)'
        }
    };

    const renderModals = () => (
        <>
            <ReserveModal/>
            <LoginOrRegistrationModal/>
        </>
    );
    
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Header style={{padding: 0, margin: 0, height: `364px`}}>
                <AppHeader />
            </Header>

            <Content style={{ padding: 0 }}>
                <Suspense fallback={<div style={{ textAlign: 'center', padding: '50px' }}><Spin size="large" /></div>}>
                    <Outlet />
                </Suspense>
                {renderModals()}
            </Content>

            <Footer style={{padding: 0}}>
                <AppFooter />
            </Footer>

            
            {location.pathname === getRootPageRoute() && isSidebarOpen && (isMobile || isTablet) && (
                <Drawer
                    closable={false}
                    placement="left"
                    open={isSidebarOpen}
                    onClose={() => hideSidebar()}
                    styles={drawerStyles}
                    // style={{width: '514px'}}
                >
                    <MtpFiltersBar/>
                </Drawer>
            )}

            {loading && <div className="fixed top-[50%] left-[50%]">
                <Spin indicator={<LoadingOutlined spin/>} size="large"/>
            </div>}
        </Layout>
    );
}